import { nanoIdSchema } from "../shared/id.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/internal/referral.ts
const internalReferralBindInputSchema = z.object({
	inviterId: nanoIdSchema,
	inviteeId: nanoIdSchema
});
const internalReferralBindOutputSchema = z.object({
	inviterId: z.string(),
	inviteeId: z.string(),
	referrerCode: z.string()
});
const internalReferralContract = oc.prefix("/internal/referral").tag("InternalReferral").router({ bind: oc.route({
	method: "POST",
	path: "/bind",
	summary: "Bind two existing users as inviter/invitee in the referral system"
}).input(internalReferralBindInputSchema).output(internalReferralBindOutputSchema).errors({
	USER_NOT_FOUND: {
		status: 404,
		message: "User not found"
	},
	SAME_USER: {
		status: 400,
		message: "Inviter and invitee must be different users"
	},
	ALREADY_HAS_REFERRER: {
		status: 409,
		message: "Invitee already has a referrer"
	}
}) });
//#endregion
export { internalReferralBindInputSchema, internalReferralContract };
